import React from "react";

/** Icônes AVI two-tone « maison » — couleurs figées (jamais currentColor), viewBox 40×40. */
const base = (size, style) => ({
  width: size, height: size, flexShrink: 0, display: "inline-block", ...style,
});

export function AviValidationIcon({ size = 20, style, className, ...rest }) {
  const { muted, ...svgRest } = rest;
  return (
    <svg viewBox="0 0 40 40" style={base(size, style)} className={className} aria-hidden="true" data-testid="avi-icon-validation" {...svgRest}>
      <path d="M15 25L12 37L17 34L19 30Z" fill="#4A4EA8" />
      <path d="M25 25L28 37L23 34L21 30Z" fill="#4A4EA8" />
      <circle cx="20" cy="17" r="11.5" fill="#5B5FC7" />
      <circle cx="20" cy="17" r="8" fill="#B9BBEE" />
      <path d="M16 17.5l3 3 5.5-6" fill="none" stroke="#5B5FC7" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function AviAccuseIcon({ size = 20, style, className, ...rest }) {
  const { muted, ...svgRest } = rest;
  return (
    <svg viewBox="0 0 40 40" style={base(size, style)} className={className} aria-hidden="true" data-testid="avi-icon-accuse" {...svgRest}>
      <rect x="10" y="4" width="20" height="17" rx="2" fill="#fff" />
      <rect x="13" y="9" width="14" height="1.7" rx="0.8" fill="#FCD487" />
      <rect x="13" y="12.5" width="14" height="1.7" rx="0.8" fill="#FCD487" />
      <rect x="13" y="16" width="9" height="1.7" rx="0.8" fill="#FCD487" />
      <path d="M6 15H34V31A2 2 0 0 1 32 33H8A2 2 0 0 1 6 31Z" fill="#F9A826" />
      <path d="M6 16L20 26L34 16" fill="none" stroke="#C77F12" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

export function AviInformationIcon({ size = 20, style, className, ...rest }) {
  const { muted, ...svgRest } = rest;
  return (
    <svg viewBox="0 0 40 40" style={base(size, style)} className={className} aria-hidden="true" data-testid="avi-icon-information" {...svgRest}>
      <path d="M8 9A3 3 0 0 1 11 6H29A3 3 0 0 1 32 9V23A3 3 0 0 1 29 26H18L12 31V26H11A3 3 0 0 1 8 23Z" fill="#2A9A7A" />
      <path d="M8 9A3 3 0 0 1 11 6H29A3 3 0 0 1 32 9V12H8Z" fill="#9FE1CB" />
      <circle cx="20" cy="15.5" r="1.6" fill="#fff" />
      <rect x="18.5" y="18" width="3" height="6" rx="1.5" fill="#fff" />
    </svg>
  );
}

export const AVI_ICONS = { validation: AviValidationIcon, accuse: AviAccuseIcon, information: AviInformationIcon };
